import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { HomeComponent } from "./pages/home/home.component";
import { HomeRoutingModule } from "./home-routing.module";
import { CoreModule } from "../../core/core.module";
import { CalculateModule } from "../../calculator/calc.module";
import { MatLegacyCardModule as MatCardModule } from "@angular/material/legacy-card";

@NgModule({
  imports: [CommonModule, HomeRoutingModule, CoreModule, CalculateModule,MatCardModule],
  declarations: [HomeComponent],
  exports: [HomeComponent]
})
export class HomeModule {}
